import React from 'react';
import { FAQAccordion } from './FAQAccordion';
const faqs = [{
  question: '¿Es un producto físico?',
  answer: 'No. Es un producto digital de descarga inmediata. Podrás leerlo en tu celular, tablet o computadora al instante.'
}, {
  question: '¿Necesito conocimientos previos?',
  answer: 'No. Está explicado de forma simple y clara, paso a paso, para que cualquiera pueda aplicarlo.'
}, {
  question: '¿Para quién es este manual?',
  answer: 'Para mujeres adultas y familias que buscan soluciones naturales, prácticas y económicas para el día a día.'
}, {
  question: '¿El acceso es limitado?',
  answer: 'No. El acceso es de por vida. Pagás una sola vez y es tuyo para siempre, incluyendo futuras actualizaciones.'
}];
export function FAQSection() {
  return <section className="py-20 bg-white px-4 sm:px-6 lg:px-8" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <h2 className="text-3xl font-serif font-bold text-center text-[#5C4033] mb-12" data-id="element-57">
          Preguntas Frecuentes
        </h2>
        <div className="bg-[#F9F4EF] rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-58">
          {faqs.map((faq, index) => <FAQAccordion key={index} {...faq} data-id="element-59" />)}
        </div>
      </div>
    </section>;
}